<!-- template for the modal component -->
<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-main-container">
            <div class="modal-dialog" :class="[modalSize, modalType]">
              <div class="modal-content"  >
                  <div class="modal-header">
                    <button type="button" class="close" @click="$emit('close')">
                        <span aria-hidden="true">×</span>
                    </button>
                    <slot name="header">
                      <h5 slot="header" style="margin-bottom:0">INFORMATION</h5>
                    </slot>
                  </div>
                  <div class="modal-body " >
                    <slot name="body">
                      <p>Check Frequently Asked Question for more information.</p>
                    </slot>
                    <slot name="support">
                       Need any help? Please contact support <a href="">here</a>.
                    </slot>
                  </div>
              </div>
              <!-- <div class="modal-footer">
                <slot name="footer">
                  empty
                </slot>
              </div> -->
            </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    name: 'modal',
    props: {
      modalSize: {
        type: String
      },
      modalType: {
        type: String
      }
    }
  }
</script>
<style>
 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: grid;
  transition: opacity .1s ease;
  bottom: 0;
}
.modal-wrapper {
  display: table-cell;
  /*vertical-align: middle;*/
}
.modal-dialog {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header {
  /*color: #fff;*/
  /*background-color: #67c2ef;*/
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}
.modal-header h3 {
  margin-top: 0;
}
.modal-default-button {
  float: right;
}

.modal-dialog {
    border-radius: 4px;
}

.modal-header {
    border-bottom: none;
    padding-bottom: 0px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.modal-table-wrap {
  overflow-x: auto;
}
.modal-main-container{
  position:fixed;
  width:100%;
  overflow: auto;
  height: 100vh;
}
</style>


// WEBPACK FOOTER //
// Modal.vue?22695b02